import {
  UserCircle2,
  Pencil,
  MessageSquare,
  ShieldCheck,
  ClipboardList,
  History,
} from "lucide-react";
import { formatDateTime } from "../../utils/progressUtils";

const ACTION_ICONS = {
  "Input progres": Pencil,
  "Tandai selesai": ShieldCheck,
  "Catatan koordinasi": MessageSquare,
  "Verifikasi Ketua Tim": ShieldCheck,
  "Input awal": ClipboardList,
};

const ROLE_COLOR = {
  ADMIN: "text-amber-700",
  IRBAN: "text-slate-800",
  DALNIS: "text-blue-700",
  KETUA_TIM: "text-emerald-700",
  ANGGOTA_TIM: "text-slate-600",
};

export default function HistoryTimeline({ history = [] }) {
  if (!history || history.length === 0) {
    return (
      <div
        data-testid="history-empty"
        className="rounded-md border border-dashed border-gray-300 bg-gray-50 px-4 py-6 text-center"
      >
        <History className="mx-auto h-5 w-5 text-slate-400" strokeWidth={1.8} />
        <div className="mt-2 text-[12.5px] font-semibold text-slate-700">
          Belum ada riwayat
        </div>
        <p className="mt-0.5 text-[11.5px] text-slate-500">
          Semua perubahan progres akan tercatat di sini.
        </p>
      </div>
    );
  }

  return (
    <ol className="space-y-3" data-testid="history-timeline">
      {history.map((h) => {
        const Icon = ACTION_ICONS[h.action] || Pencil;
        return (
          <li
            key={h.id}
            data-testid={`history-item-${h.id}`}
            className="flex gap-3 rounded-md border border-gray-200 bg-white p-3"
          >
            <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-[#e8edf2] text-[#1e3a5f]">
              <Icon className="h-4 w-4" strokeWidth={2} />
            </div>
            <div className="min-w-0 flex-1">
              <div className="flex flex-wrap items-center gap-x-2 gap-y-0.5">
                <span className="text-[12.5px] font-semibold text-slate-900">
                  {h.action}
                </span>
                <span className="text-[10.5px] text-slate-400">·</span>
                <span className="inline-flex items-center gap-1 text-[11.5px] text-slate-600">
                  <UserCircle2 className="h-3 w-3 text-slate-400" strokeWidth={1.8} />
                  <span className="font-medium">{h.userName}</span>
                  {h.userRole ? (
                    <span className={`text-[10px] font-semibold ${ROLE_COLOR[h.userRole] || "text-slate-500"}`}>
                      ({h.userRole.replace("_", " ").toLowerCase()})
                    </span>
                  ) : null}
                </span>
              </div>
              {h.catatan ? (
                <div className="mt-1 whitespace-pre-wrap rounded-md bg-slate-50 px-2 py-1.5 text-[12px] text-slate-700">
                  {h.catatan}
                </div>
              ) : null}
              <div className="mt-1 text-[10.5px] text-slate-400">
                {formatDateTime(h.timestamp)}
              </div>
            </div>
          </li>
        );
      })}
    </ol>
  );
}
